<div container [isFluid]="true" [noGutters]="true">
  <div class="why-screen__decorator" decorator [lineLeft]="decorator"></div>
  <div class="why-screen d-flex flex-column flex-lg-row">
    <div class="why-screen__text text-white">
      <h2>Don’t wait until it’s too late.</h2>
      <p class="mb-0">
        If T1D is not spotted early, there can be serious health risks. Up to
        62% of people receive a T1D diagnosis in an emergency setting that
        requires hospitalization. But it doesn’t have to be that way. Screening
        can help spot T1D before symptoms are even present.
      </p>
    </div>
  </div>
</div>
